import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  TravelPlans: {
    marginBottom: '8px',
  },
}));

export default useStyles;
